/** @format */

/* eslint-disable */
import React, { useEffect, useState } from 'react'
import localize from '../../../Global/Localize'
import {
  formatAsPercent,
  formatCurrency,
  formatDate,
} from '../../../Helpers/formatters'
import { getData } from '../../../Helpers/webApi'
import Checkbox from '../../Checkbox/Checkbox'
import Pager from '../../Tables/Pager'
import SimpleTable from '../../Tables/SimpleTable'
import Loader from '../../Loaders/Loader'

const ListInvestmentProducts = ({
  selectedInvestmentProducts,
  handleSelectInvestmentProduct,
  handleSelectAllInvestmentProducts,
  handleUpdateInvestmentProducts,
  resetValues,
  setResetValues,
  actionText,
}) => {
  const [isBusy, setIsBusy] = useState(false)
  const [investmentProducts, setInvestmentProducts] = useState([])
  const [selectAllInvestments, setSelectAllInvestments] = useState(false)
  const [reqParams, setReqParams] = useState({
    filterText: '',
    pageIndex: 0,
    pageSize: 10,
  })

  const columns = [
    {
      label: localize('select') + '?',
      template: r => (
        <Checkbox
          checked={selectedInvestmentProducts.find(c => c.id === r.id)}
          onCheck={v => {
            handleSelectInvestmentProduct(r, v)
          }}
        />
      ),
    },
    {
      label: localize('code'),
      template: r => r.paddedCode,
    },
    {
      label: localize('name'),
      template: r => r.description,
    },
    {
      label: localize('minimumBalance'),
      template: r => formatCurrency(r.minimumBalance),
    },
    {
      label: localize('maximumBalance'),
      template: r => formatCurrency(r.maximumBalance),
    },
    {
      label: localize('annualPercentageYield'),
      template: r => formatAsPercent(r.annualPercentageYield),
    },
    {
      label: localize('gLAccountName'),
      template: r => r.chartOfAccountName,
    },
    {
      label: localize('gLAccountCostDistrRule'),
      template: r => r.chartOfAccountCostDistributionRuleDescription,
    },
    {
      label: localize('poolGLAccountName'),
      template: r => r.poolChartOfAccountName,
    },
    {
      label: localize('poolGLAccountCostDistrRule'),
      template: r => r.poolChartOfAccountCostDistributionRuleDescription,
    },
    {
      label: localize('isRefundable') + ' ?',
      template: r => r.isRefundable?.toString(),
    },
    {
      label: localize('isPooled') + ' ?',
      template: r => r.isPooled?.toString(),
    },
    {
      label: localize('poolAmount'),
      template: r => formatCurrency(r.poolAmount),
    },
    {
      label: localize('recoveryPriority'),
      template: r => r.priority,
    },
    {
      label: localize('maturityPeriod') + localize('(months)'),
      template: r => r.maturityPeriod,
    },
    {
      label: localize('isLocked') + ' ?',
      template: r => r.isLocked?.toString(),
    },
    {
      label: localize('createdDate'),
      template: r => formatDate(r.createdDate),
    },
  ]

  const fetchInvestmentProducts = async () => {
    setIsBusy(true)
    const url = '/InvestmentProduct/find-investment-product-by-filter-in-page'

    const { success, data } = await getData(url, reqParams, false)

    if (success) {
      setIsBusy(false)
      setInvestmentProducts(data)
    } else {
      setIsBusy(false)
    }
  }

  useEffect(() => {
    fetchInvestmentProducts()

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reqParams.pageIndex, reqParams.pageSize])

  useEffect(() => {
    if (resetValues) {
      setSelectAllInvestments(false)
      setResetValues(false)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [resetValues])

  return (
    <>
      {isBusy ? (
        <Loader />
      ) : (
        <>
          <div className="row mb-2 py-3 px-2">
            <div className="col-md-4">
              <div className="d-flex align-items-center">
                <label
                  htmlFor="recordsPerPage"
                  className="text-capitalize"
                  style={{ marginLeft: -10, textTransform: 'capitalize' }}
                >
                  {localize('recordsPerPage')}
                </label>
                <select
                  id="recordsPerPage"
                  className="form-select ms-3"
                  style={{ maxWidth: 'fit-content' }}
                  defaultValue={reqParams.pageSize}
                  onChange={e => {
                    setReqParams({
                      ...reqParams,
                      pageIndex: 0,
                      pageSize: e.target.value,
                    })
                  }}
                >
                  <option value="10">10</option>
                  <option value="20">20</option>
                  <option value="50">50</option>
                  <option value="100">100</option>
                </select>
              </div>
            </div>
            <div className="col-md-3 offset-md-5">
              <div className="d-flex align-items-center justify-content-end">
                <label className="text-capitalize me-2">
                  {localize('search')}
                </label>
                <input
                  type="search"
                  id="searchTable"
                  className="form-control ms-2"
                  value={reqParams.filterText}
                  onChange={e => {
                    if (e.target.value === '') {
                      fetchInvestmentProducts()
                    }

                    setReqParams({
                      ...reqParams,
                      filterText: e.target.value,
                    })
                  }}
                  onKeyDown={e => {
                    if (e.key === 'Enter') {
                      fetchInvestmentProducts()
                    }
                  }}
                />
                <button
                  id="FilterButton"
                  type="button"
                  className="btn btn-primary ms-2"
                  onClick={() => {
                    fetchInvestmentProducts()
                  }}
                >
                  <i className="uil uil-filter"></i>
                </button>
              </div>
            </div>
          </div>
          <div
            style={{
              maxHeight: '50dvh',
              overflowY: 'auto',
              overflowX: 'hidden',
            }}
          >
            <SimpleTable
              columns={columns}
              data={investmentProducts?.pageCollection}
            />
          </div>
          <div className="mb-2"></div>
          <Pager
            itemsCount={investmentProducts.itemsCount}
            pageSize={reqParams.pageSize}
            pageIndex={reqParams.pageIndex}
            pageBatchSize={10}
            onPageChange={p => setReqParams({ ...reqParams, pageIndex: p })}
          />
          <div className="py-3 row px-1 bg-light mt-3 mx-2 rounded">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex justify-content-start gap-3 align-items-center">
                <div className="d-flex align-items-center">
                  <Checkbox
                    id="selectAllInvestmentsProduct"
                    checked={selectAllInvestments}
                    onCheck={v => {
                      setSelectAllInvestments(v)
                      handleSelectAllInvestmentProducts(
                        investmentProducts.pageCollection,
                        v
                      )
                    }}
                  />

                  <label
                    htmlFor="selectAllInvestmentsProduct"
                    className="ms-2 text-capitalize"
                  >
                    {localize('toggleSelection')}
                  </label>
                </div>
              </div>

              <div className="d-flex align-items-center float-end">
                <button
                  onClick={handleUpdateInvestmentProducts}
                  className="btn btn-success float-end"
                >
                  {localize(actionText || 'update')}
                </button>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  )
}

export default ListInvestmentProducts
